import { render, staticRenderFns } from "./FiltersAttributionsTreated.vue?vue&type=template&id=99fc471c"
import script from "./FiltersAttributionsTreated.vue?vue&type=script&lang=js"
export * from "./FiltersAttributionsTreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports